import React from "react";
import { useOffline } from "./OfflineProvider";

export default function SidebarInfoText() {
  const { isOnline } = useOffline();
  return (
    <div className="info-text">
      {isOnline
        ? "KI-gestützter Dokumentationsassistent für verbesserte Produktivität"
        : "Offline-Modus – gespeicherte Dokumente und Daten werden verwendet"}
    </div>
  );
}
